module.exports = __webpack_public_path__ + "img/game_tiyu_pingpang.9a980cf3.png";